export const getHierarchy = (data, id) => {
    if (data.resourceId?.includes(id)) {
        return data;
    }
    if (data.items && data.items?.length > 0) {
        for (const item of data.items) {
            const result = getHierarchy(item, id);
            if (result) {
                return result;
            }
        }
    }
    return null;
};
export const getListOfSubHierarchy = (items) => {
    return items?.map(({ resourceId }) => {
        const resorceId = resourceId?.split('/');
        return resorceId[resorceId?.length - 1];
    });
};
export const getFilteredCollection = (collectionsToFind, collections) => {
    return collections?.filter((collection) => {
        if (collectionsToFind?.includes(collection?.id)) {
            return collection;
        }
    });
};
